
import { defineComponent } from 'vue'
import TestModeSelector from '@/components/common/ui/TestModeSelector.vue'
import ExportPanel from '@/components/log/ExportPanel.vue'
import ExportList from '@/components/log/ExportList.vue'

export default defineComponent({
  name: 'LogReport',
  components: {
    TestModeSelector,
    ExportPanel,
    ExportList,
  },
  data() {
    return {
      isTestMode: false,
    }
  },
  computed: {
    appId(): string {
      return this.$route.params.app_id as string
    },
  },
})
